import React from 'react';
import Kasumikalk from 'views/Kasumikalk';
import NotFound from 'views/NotFound';
import NotAuthorised from 'views/NotAuthorised';
import NotAuthenticated from 'views/NotAuthenticated';
import Login from 'views/Login';
import RouterTest from 'views/RouterTest';
import Beeper from 'views/Beeper';
import SheetCalculator from 'views/SheetCalculator';
import Imposer from 'views/Imposer';

const routes = {
  Examples: [
    {
      name: 'Home',
      pattern: '/',
      main: () => <div>Home</div>
    }, {
      name: 'About',
      pattern: '/about',
      main: () => <div>About</div>
    }
  ],
  Raha: [
    {
      access: ['admin'],
      name: 'Kasumikalk',
      pattern: '/kasumikalk',
      main: () => <Kasumikalk />
    }
  ],
  Test: [
    {
      name: 'RouterTest',
      pattern: '/test/:text',
      main: (extra) => <RouterTest extra={extra} />
    },
  ],
  Lakrito: [
    {
      name: 'Piiksutaja',
      pattern: '/piiksutaja',
      access: ['developer', 'employee'],
      edit: ['beeperEditor'],
      main: () => <Beeper />
    }, {
      name: 'Poogna Kalkulaator',
      pattern: '/sheetcalc',
      access: ['developer', 'tester'],
      main: () => <SheetCalculator />
    }, {
      name: 'Imposer',
      pattern: '/imposer',
      access: ['developer'],
      main: () => <Imposer />
    }
  ]
};

export const loginRoute = {
  name: 'Login',
  main: () => <Login />
};

export const notFoundRoute = {
  name: 'not-found',
  main: () => <NotFound />
};

export const authenticateRoute = {
  name: 'not-authenticated',
  main: () => <NotAuthenticated />
};

export const notAuthorisedRoute = {
  name: 'not-authorised',
  main: () => <NotAuthorised />
};

export const routesArray = Object.keys(routes).reduce((acc, key) => [...acc, ...routes[key]], []);

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js